<template>
  <div class="start">
    <b-form @submit="submitForm">
      <b-form-group id="station-number-group">
        <label label-for="station-number">
          Vehicle Testing Station Number
          <span class="text-danger">*</span>
        </label>
        <b-form-input
          class="uppercase"
          v-model="vtsNumber"
          variant="success"
          id="station-number"
          type="text"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="contact-name-group">
        <label label-for="contact-name">
          Primary Contact Name
          <span class="text-danger">*</span>
        </label>
        <b-form-input v-model="contact.name" id="contact-name" type="text" required></b-form-input>
      </b-form-group>

      <b-form-group id="contact-email-group">
        <label label-for="contact-email">
          Primary Contact Email
          <span class="text-danger">*</span>
        </label>
        <b-form-input v-model="contact.email" id="contact-email" type="email" required></b-form-input>
      </b-form-group>

      <!-- <p class="pt-4 pb-3">Would you be happy for us to send you the occasional email to let you know about improvements to our service? You can opt out any time.</p> -->

      <b-form-group id="checkboxes-form-group">
        <b-form-checkbox
          class="pt-3 pb-3"
          v-model="privacy.agreesContact">Please keep us notified about future improvements and additions to the TestWatcher service.<br>(Recommended for all VTS's - you can opt out at any time)</b-form-checkbox>
        <b-form-checkbox class="pb-3" v-model="privacy.agreesPrivacy">
          I understand that my contact details will be stored and used in accordance with the VITC
          <router-link to="privacy" target="_blank">privacy policy</router-link>
        </b-form-checkbox>
      </b-form-group>

      <b-alert :show="$store.state.viewState == 'Error'" variant="danger">
        <span v-if="$store.state.error">{{ $store.state.error }}</span>
        Error processing activation, please contact our team directly who will be glad to assist.
      </b-alert>

      <b-button
        block
        size="lg"
        type="submit"
        variant="success"
        :disabled="!privacy.agreesPrivacy || isProcessing"
      >
        Next
        <span class="mdi mdi-login-variant ml-2" v-if="!isProcessing"></span>
        <span class="mdi mdi-loading mdi-spin ml-2" v-if="isProcessing"></span>
      </b-button>
    </b-form>
  </div>
</template>

<script>
export default {
  name: "start",
  data() {
    return {
      isProcessing: false,
      vtsNumber: "",
      contact: {
        name: "",
        email: ""
      },
      privacy: {
        agreesContact: true,
        agreesPrivacy: false
      }
    };
  },
  methods: {
    async submitForm(e) {
      e.preventDefault();
      this.isProcessing = true;
      this.$store.dispatch("storeContactPrivacy", [this.contact, this.privacy]);
      await this.$store.dispatch("vtsLookup", this.vtsNumber.trim().toUpperCase());
      this.$router.push({ name: "activate-confirm" });
      this.isProcessing = false;
    }
  }
};
</script>